import apiClient from './axios';

export const getDocuments = (params) => apiClient.get('/api/v1/documents', { params });
export const createDocument = (data) => apiClient.post('/api/v1/documents', data);
export const updateDocument = (id, data) => apiClient.put(`/api/v1/documents/${id}`, data);
export const deleteDocument = (id) => apiClient.delete(`/api/v1/documents/${id}`);
export const bulkDeleteDocuments = (ids) => apiClient.post('/api/v1/documents/bulk-delete', { ids });
export const updateDocumentSharing = (id, data) => apiClient.patch(`/api/v1/documents/${id}/sharing`, data);
export const getSharedDocument = (token) => apiClient.get(`/api/v1/documents/shared/${token}`);
